import React from 'react'
import { Controller } from 'react-hook-form'
import MenuItem from '@material-ui/core/MenuItem'
import Select from '@material-ui/core/Select'
import InputLabel from '@material-ui/core/InputLabel'
import Checkbox from '@material-ui/core/Checkbox'
import FormControl from '@material-ui/core/FormControl'
import { ListSubheader } from '@material-ui/core'
import { useController } from 'react-hook-form'
import { HelperText } from '../../form/components/inputs'

const AreaOfWorkSelectField = ({
  control,
  name,
  label,
  options,
  t,
  className,
  clearErrors,
  defaultValue,
  disabled,
  setIsFormEdit
}) => {
  const {
    fieldState: { invalid, error }
  } = useController({
    name,
    control,
    defaultValue: defaultValue ?? []
  })
  return (
    <FormControl error={invalid} style={{ marginTop: '32px' }}>
      <InputLabel
        shrink
        style={{
          marginTop: '-8px',
          fontSize: '20px',
          opacity: disabled ? 0.7 : 1
        }}
      >
        {label}
      </InputLabel>
      <Controller
        name={name}
        control={control}
        defaultValue={[]}
        render={({ field }) => (
          <>
            <Select
              multiple
              value={field.value}
              className={className}
              disableUnderline={true}
              onChange={(e) => {
                field.onChange(e.target.value)
                clearErrors(['offerTo'])
                setIsFormEdit(true)
              }}
              label={label}
              disabled={disabled}
              renderValue={(selected) => {
                const clean_selected = cleanArray(selected)
                if (
                  (clean_selected.length === 1 && clean_selected[0] === '') ||
                  clean_selected.length === 0
                ) {
                  return ''
                } else if (
                  clean_selected.length === 1 &&
                  clean_selected[0] !== ''
                ) {
                  return t(`employer.areaOfWork.${clean_selected[0]}`)
                } else if (
                  clean_selected.length > 1 &&
                  clean_selected[0] !== ''
                ) {
                  return (
                    t(`employer.areaOfWork.${clean_selected[0]}`) +
                    (clean_selected.length > 1
                      ? ` + ${clean_selected.length - 1} ${t(
                          'employer.assignments.more'
                        )}`
                      : '')
                  )
                }
                return (
                  t(`employer.areaOfWork.${clean_selected[1]}`) +
                  (clean_selected.length > 2
                    ? ` + ${clean_selected.length - 2} ${t(
                        'employer.assignments.more'
                      )}`
                    : '')
                )
              }}
            >
              <MenuItem value="" disabled>
                {t('employer.assignments.label12b')}
              </MenuItem>
              {options?.map((area) => createWorkItems(t, area, field))}
            </Select>
            <HelperText
              invalid={invalid}
              error={error}
              style={{ marginTop: '0px', height: '0px' }}
            />
          </>
        )}
      />
    </FormControl>
  )
}

const createWorkItems = (t, area, field) => {
  const items = area.child.map((a) => {
    return (
      <MenuItem key={a.Id} value={a.Id}>
        <Checkbox color="primary" checked={field.value.includes(a.Id)} />
        {t(`employer.areaOfWork.${a.Id}`)}
      </MenuItem>
    )
  })
  return [
    <ListSubheader
      color="primary"
      disableSticky={true}
      style={{ fontSize: '12px', backgroundColor: '#F3FBFC' }}
    >
      {t(`employer.areaOfExpertiseList.${area.Id}`)}
    </ListSubheader>,
    items
  ]
}

function cleanArray(arr) {
  if (arr[0] === undefined || arr[0] === '') {
    return arr.slice(1)
  }
  return arr
}

export default AreaOfWorkSelectField
